import fetchFundingRateHistory from '@lyra/core/api/fetchFundingRateHistory'
import { PublicGetFundingRateHistoryParamsSchema } from '@lyra/core/api/types/public.get_funding_rate_history'
import { useMemo } from 'react'
import useSWR from 'swr'

import useTicker from './useTicker'

export type FundingRateData = {
  fundingRate: number
  timestamp: number
}

const fetcher = async (
  instrument: string,
  latestFundingRate: number
): Promise<FundingRateData[]> => {
  const params: PublicGetFundingRateHistoryParamsSchema = {
    instrument_name: instrument,
    period: 3600,
  }

  const { result } = await fetchFundingRateHistory(params)

  const formattedData = result.funding_rate_history
    .map((f) => ({
      fundingRate: +f.funding_rate,
      timestamp: f.timestamp,
    }))
    .sort((a, b) => a.timestamp - b.timestamp)

  return [...formattedData, { fundingRate: latestFundingRate, timestamp: Date.now() }]
}

export default function useFundingRateHistory(instrument: string) {
  const ticker = useTicker(instrument)
  const latestFundingRate = ticker ? parseFloat(ticker.perp_details.funding_rate) : 0

  const { data, error, isLoading } = useSWR(
    [`FundingRateHistory`, instrument],
    () => fetcher(instrument, latestFundingRate),
    {
      keepPreviousData: true,
    }
  )

  return useMemo(() => ({ data: data, isLoading, isError: error }), [data, error, isLoading])
}
